import Brand from './Brand'

export default Brand
